import React from 'react';
import PropTypes from 'prop-types';
import { I18nText } from '@welldev-group/react-comp-lib';
import SanitizedHTML from '../../../../../shared/components/SanitizedHTML';
import DateTime from '../../../DateTime';

const AffiliateLog = ({ affiliateLog }) => (
  <div>
    <div>
      <div>
        <span>
          <I18nText id="affiliate_three_sixty.affiliate.log.date" />
          <DateTime dateTime={affiliateLog.incidentAt} format="short" />
        </span>
      </div>
      <div>
        {I18n.t('components.affiliate_three_sixty.affiliate.log.by', {
          logger_name: affiliateLog.loggerName,
        })}
      </div>
    </div>
    <div className="affiliate-log__summary">
      {I18n.t('components.affiliate_three_sixty.affiliate.log.summary', {
        summary: affiliateLog.summary,
      })}
    </div>
    <div>
      <SanitizedHTML html={affiliateLog.body} />
    </div>
  </div>
);

AffiliateLog.propTypes = {
  affiliateLog: PropTypes.shape({
    incidentAt: PropTypes.string.isRequired,
    loggerName: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
  }).isRequired,
};

export default AffiliateLog;
